(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-spin-wheel"]) return;
  try {
    
if(!customElements.get('sn-spin-wheel'))customElements.define('sn-spin-wheel',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.dialog=this.querySelector('dialog');if(!this.dialog)return;
    this.config=JSON.parse(this.querySelector('[data-snw-config]').textContent);
    this.demo=this.dataset.demo==='true';this.key='snw:'+this.dataset.campaign;
    this.spin=this.querySelector('[data-snw-spin]');this.launch=this.querySelector('[data-snw-open]');this.angle=0;this.busy=false;
    this.launch.hidden=false;this.launch.addEventListener('click',()=>this.open());
    this.querySelector('[data-snw-close]').addEventListener('click',()=>this.dialog.close());
    this.dialog.addEventListener('close',()=>{try{sessionStorage.setItem(this.key+':seen','1');}catch{}});
    this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
    this.spin.addEventListener('click',()=>this.turn());
    this.querySelector('[data-snw-copy]').addEventListener('click',async e=>{try{await navigator.clipboard.writeText(this.config.codes[this.winner%2]);e.target.textContent=this.dataset.copiedLabel;}catch{const selection=window.getSelection();const range=document.createRange();range.selectNodeContents(this.querySelector('[data-snw-code]'));selection.removeAllRanges();selection.addRange(range);}});
    if(!this.demo){try{const old=JSON.parse(localStorage.getItem(this.key));if(old&&old.expires>Date.now()&&Number.isInteger(old.index)&&old.index>=0&&old.index<6)this.result(old.index);}catch{}}
    let seen=false;try{seen=sessionStorage.getItem(this.key+':seen')==='1';}catch{}
    if(this.dataset.auto==='true'&&!this.demo&&!this.won&&!seen){this.autoTimer=setTimeout(()=>{if(!document.hidden&&!document.querySelector('dialog[open],cart-drawer.active'))this.open();},Number(this.dataset.delay)*1000);}
  }
  disconnectedCallback(){clearTimeout(this.autoTimer);clearTimeout(this.timer);}
  open(){if(!this.dialog.open)this.dialog.showModal();try{sessionStorage.setItem(this.key+':seen','1');}catch{}}
  turn(){
    if(this.busy||this.won)return;this.busy=true;this.spin.disabled=true;this.spin.textContent=this.dataset.spinningLabel;
    const values=new Uint32Array(1);crypto.getRandomValues(values);const index=values[0]%6;
    this.angle=2160+(360-(index*60+30));this.querySelector('.snw-disc').style.transform='rotate('+this.angle+'deg)';
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.timer=setTimeout(()=>{this.result(index);this.busy=false;if(!this.demo){try{localStorage.setItem(this.key,JSON.stringify({index,expires:Date.now()+Number(this.dataset.days)*86400000}));}catch{}}},reduced?100:4700);
  }
  result(index){
    this.winner=index;this.won=true;this.spin.hidden=true;
    const disc=this.querySelector('.snw-disc');disc.style.transition='none';disc.style.transform='rotate('+(2160+360-(index*60+30))+'deg)';this.querySelector('[data-snw-result]').hidden=false;
    this.querySelector('[data-snw-win]').textContent=this.dataset.resultLabel+' '+(index%2===0?'3%':'5%');
    if(this.demo){const note=this.querySelector('[data-snw-demo-note]');note.textContent=this.dataset.demoResult;note.hidden=false;return;}
    const code=this.config.codes[index%2];this.querySelector('[data-snw-code]').textContent=code;this.querySelector('[data-snw-code-wrap]').hidden=false;
    const apply=this.querySelector('[data-snw-apply]');apply.href='/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(this.config.shopUrl);apply.hidden=false;
  }
});

  } catch(e) { console.error(e); }
})();
})();
